import * as types from './types';

function setPartnerDetails(data) {
    return {
        type: types.SET_PARTNER_DETAILS,
        payload: data,
    };
}

export {
    setPartnerDetails,
};
